module.exports = __webpack_public_path__ + "static/media/YakChatLogo_Horizantal.6a88a26e.svg";